
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 19","data-token-name":"text-multiple-styles"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.763 15L2.406 6.154h-.054c.018.187.034.415.047.684a39.818 39.818 0 01.048 1.846V15h-1.08V5.006H3.09l3.165 8.312h.048l3.213-8.312h1.709V15h-1.149V8.602c0-.297.005-.593.014-.89a40.857 40.857 0 01.075-1.544h-.055L6.713 15h-.95zm12.835-2.28c0 .508-.127.942-.381 1.301-.25.356-.602.627-1.055.815-.453.187-.986.281-1.6.281-.324 0-.63-.015-.92-.047a6.247 6.247 0 01-.796-.135 3.386 3.386 0 01-.639-.216v-.955a7.8 7.8 0 001.072.34c.422.101.864.152 1.325.152.43 0 .793-.057 1.09-.17.296-.117.52-.283.673-.498.156-.219.235-.48.235-.785 0-.293-.065-.537-.194-.733-.129-.199-.344-.379-.644-.539a8.507 8.507 0 00-1.22-.521 6.55 6.55 0 01-.96-.422 2.994 2.994 0 01-.697-.527 1.985 1.985 0 01-.428-.68 2.579 2.579 0 01-.14-.885c0-.457.115-.848.345-1.172a2.2 2.2 0 01.967-.75c.414-.176.889-.263 1.424-.263a5.647 5.647 0 012.338.474l-.311.856a6.76 6.76 0 00-.984-.323 4.381 4.381 0 00-1.067-.129c-.367 0-.677.055-.931.165-.25.105-.442.255-.575.45a1.21 1.21 0 00-.199.698c0 .3.063.55.188.75.129.2.332.377.609.533.281.152.652.313 1.113.48.504.184.932.38 1.284.587.351.203.619.453.802.75.184.293.276.666.276 1.119z","fill":"currentColor"}})])
          )
        }
      }
    